import { ArrowUp, LogIn } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const footerLinks = [
  {
    title: "Peptides",
    links: [
      { label: "Weight Management", href: "/peptides/weight-management" },
      { label: "Anti-Aging", href: "/peptides/anti-aging" },
      { label: "Muscle Recovery", href: "/peptides/muscle-recovery" },
      { label: "Cognitive Health", href: "/peptides/cognitive-health" },
      { label: "Immune Support", href: "/peptides/immune-support" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Our Physicians", href: "/physicians" },
      { label: "Research", href: "/research" },
      { label: "Careers", href: "/careers" },
      { label: "Press", href: "/press" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Pricing", href: "/pricing" },
      { label: "Contact Us", href: "/contact" },
      { label: "FAQ", href: "/faq" },
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "HIPAA Compliance", href: "/hipaa" },
      { label: "Staff Login", href: "/admin/login?staff=true" },
    ],
  },
];

export default function FooterSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#2A3324] text-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <a
              href="/"
              onClick={handleLogoClick}
              className="font-serif text-3xl font-light tracking-tight text-[#F7F5F0] inline-block mb-6"
            >
              peptides<span className="font-semibold">recovery</span>
            </a>
            <p className="text-base font-sans font-light leading-relaxed text-[#F7F5F0]/50 max-w-sm">
              Pioneering the future of personalized medicine through
              science-backed peptide therapies. Your transformation starts here.
            </p>
          </div>

          {footerLinks.map((col, i) => (
            <div key={i} className="md:col-span-2">
              <h4 className="text-sm font-sans font-medium uppercase tracking-wider text-[#F7F5F0]/40 mb-6">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <button
                      data-testid={`footer-link-${link.href.replace(/\//g, "-").slice(1)}`}
                      onClick={() => navigate(link.href)}
                      className="text-sm font-sans font-light text-[#F7F5F0]/60 hover:text-[#F7F5F0] transition-colors duration-300"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#F7F5F0]/10 mb-12" />

        {/* Large brand text */}
        <div className="flex items-end justify-between">
          <h2 className="text-5xl md:text-7xl lg:text-[8rem] font-serif font-light tracking-tighter text-[#F7F5F0]/10 leading-none uppercase">
            PeptidesRecovery
          </h2>
          <button
            data-testid="scroll-to-top-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="bg-[#F7F5F0]/10 hover:bg-[#F7F5F0]/20 rounded-full p-4 transition-all duration-300 hover:-translate-y-1 shrink-0"
          >
            <ArrowUp size={20} strokeWidth={1.5} className="text-[#F7F5F0]" />
          </button>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-sans text-[#F7F5F0]/30">
            &copy; {new Date().getFullYear()} PeptidesRecovery. All rights reserved.
          </p>
          <p className="text-xs font-sans text-[#F7F5F0]/30">
            This website does not provide medical advice. Consult a qualified physician.
          </p>
        </div>
      </div>
    </footer>
  );
}
